import VSelectCardType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardType', VSelectCardType),
};
